import { useWindowSize } from '@/hooks/useWindowSize'
import { ref } from 'vue'

const visible = ref(true)
export const usePcSideCart = () => {
  const { width } = useWindowSize()

  const showPCSideCart = () => {
    visible.value = true
  }

  const hidePCSideCart = () => {
    visible.value = false
  }

  watch(width, (width) => {
    visible.value = width >= 1280
  }, { immediate: true })

  return {
    visible,
    showPCSideCart,
    hidePCSideCart
  }
}
